import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DisplayInfoSubIcon, IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';

@Component({
    encapsulation: ViewEncapsulation.None, // has styles in common.scss, TODO
    selector: 'dl-display-info-icon',
    templateUrl: './display-info-icon.component.html',
    styleUrls: ['./display-info-icon.component.scss']
})
export class DisplayInfoIconComponent {
    public static $name: string = 'displayInfoIcon';
    @Input() public displayIcon: IDisplayInfoIcon;
    @Input() public heating: boolean;
    @Input() public cooling: boolean;
    @Input() public inline = true;
    @Input() public isButton = false;
    @Input() public flex = false;

    public getCls(icon: DisplayInfoSubIcon): string[] {
        const cls = [];

        if (this.heating) {
            cls.push('heating');
        }
        if (this.cooling) {
            cls.push('cooling');
        }

        if (this.isButton) {
            cls.push('display-info-button-icon');
        }

        if (this.inline) {
            cls.push('inline-sub-icon');
        }

        if (!icon || !icon.conditionalCls) {
            return cls;
        }

        for (const item of icon.conditionalCls) {
            if (item.condition()) {
                cls.push(item.cls);
            }
        }

        return cls;
    }
}
